import { PropsWithChildren } from "react";
import tw, { styled } from "twin.macro";

import Container from "../common/Container";
import Section, {
  SectionColor,
  SectionContent,
  SectionHeaderNoSubheadline,
  SectionHeadline,
  SectionHeadlineHighlight,
} from "../common/Section";

const Tips = styled.div`
  ${tw`grid grid-cols-3`}
  column-gap: 40px;
  row-gap: 60px;

  @media (max-width: 850px) {
    ${tw`grid-cols-2`}
  }

  @media (max-width: 500px) {
    ${tw`grid-cols-1`}
  }
`;

const GrowthResources: React.FunctionComponent<
  PropsWithChildren<{ color?: SectionColor }>
> = ({ children, color = SectionColor.White, ...props }) => (
  <Container {...props}>
    <Section color={color}>
      <SectionHeaderNoSubheadline>
        <SectionHeadline>
          <SectionHeadlineHighlight>
            Subscription growth
          </SectionHeadlineHighlight>{" "}
          resources
        </SectionHeadline>
      </SectionHeaderNoSubheadline>
      <SectionContent>
        <Tips>{children}</Tips>
      </SectionContent>
    </Section>
  </Container>
);

export default GrowthResources;
